/****************************************************
 * Module Name:  userRoleProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class UserRoleProxy {
  static AddUserRole = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/roles",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteUserRole = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/permission/roles",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddVirtualTeamRole = (vtid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/permission/roles/vt/${vtid}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteVirtualTeamRole = (vtid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/permission/roles/vt/${vtid}`,
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
